import React from 'react';
import { Search, Info } from 'lucide-react';
import { ProfileSearchResult } from './types';

interface ProfileSearchProps {
  searchDriverName: string;
  setSearchDriverName: (value: string) => void;
  searchRaceNumber: string;
  setSearchRaceNumber: (value: string) => void;
  isSearching: boolean;
  searchResults: ProfileSearchResult[];
  raceNumberError: string | null;
  onSearchDriverName: () => void;
  onSearchRaceNumber: () => void;
  onSelectSearchResult: (result: ProfileSearchResult) => void;
}

export default function ProfileSearch({
  searchDriverName,
  setSearchDriverName,
  searchRaceNumber,
  setSearchRaceNumber,
  isSearching,
  searchResults,
  raceNumberError,
  onSearchDriverName,
  onSearchRaceNumber,
  onSelectSearchResult
}: ProfileSearchProps) {
  return (
    <div className="space-y-6">
      {/* Driver Name Search */}
      <div className="bg-zinc-800 p-4 rounded-lg mb-6">
        <h4 className="text-white font-medium mb-2">Search by Driver Name</h4>
        <div className="flex gap-2">
          <div className="relative flex-1">
            <input
              type="text"
              value={searchDriverName}
              onChange={(e) => setSearchDriverName(e.target.value)}
              placeholder="Enter driver's full name"
              className="w-full bg-zinc-700 border border-zinc-600 rounded-md p-3 text-white focus:ring-2 focus:ring-primary-500 focus:outline-none"
            />
            {isSearching && (
              <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-500"></div>
              </div>
            )}
            
            {/* Search Results Dropdown */}
            {searchResults.length > 0 && (
              <div className="absolute z-10 w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-md shadow-lg max-h-60 overflow-auto">
                {searchResults.map((result, index) => (
                  <div 
                    key={index}
                    className="p-3 hover:bg-zinc-700 cursor-pointer border-b border-zinc-700 last:border-b-0"
                    onClick={() => onSelectSearchResult(result)}
                  >
                    <div className="font-medium text-white">
                      {result.first_name} {result.last_name}
                    </div>
                    {result.race_number && (
                      <div className="text-sm text-gray-400">
                        Race #: {result.race_number}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          <button
            onClick={onSearchDriverName}
            disabled={isSearching || !searchDriverName.trim()}
            className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 disabled:opacity-50"
          >
            <Search className="h-4 w-4" />
            {isSearching ? 'Searching...' : 'Search'}
          </button>
        </div>
        <p className="text-xs text-gray-400 mt-2">
          Search for a driver by name to auto-fill information 
        </p>
      </div>
    </div>
  );
} 